var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 164,
    viewBox: "0 0 68 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4461 17.5735C111.348 20.5623 132.812 14.1122 148.872 26.2392C166.803 39.7782 180.841 61.2751 178.976 83.6655C177.185 105.169 155.999 117.737 140.042 132.262C125.26 145.717 111.416 162.462 91.4461 163.342C70.8934 164.247 53.2685 150.928 38.3695 136.742C22.9943 122.102 11.6986 104.529 7.76737 83.6655C2.76566 57.121 -7.47387 22.685 13.7234 5.94278C35.094 -10.9364 64.5156 13.5291 91.4461 17.5735Z",
    fill: "#FED700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern06);
export default __webpack_public_path__ + "static/media/pattern-06.9d0c332b4989b5ccba40f76303f6ba73.svg";
export { ForwardRef as ReactComponent };